import React, { Component } from "react";

export default class progress extends Component {
  render() {
    return (
      <div className="form-progress wrapper">
        <div className="text flex space-btw">
          <p>{((this.props.current - 1) / this.props.total) * 100}% complete</p>
          <p>
            Step {this.props.current} of {this.props.total}
          </p>
        </div>
        <div className="progress" data-progress="100%">
          <span
            className="thumb"
            style={{
              width: `${((this.props.current - 1) / this.props.total) * 100}%`,
            }}
          ></span>
        </div>
          {this.props.children ? this.props.children : ""}
      </div>
    );
  }
}
